import script from "./LayerCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerCategory.vue?vue&type=script&setup=true&lang=js"

import "./LayerCategory.vue?vue&type=style&index=0&id=0bb75a07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb75a07"]])

export default __exports__